import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Autocolor } from '../models/autocolor';
import { DetalleFormulaAudit } from '../models/detalle-formula-audit';
import { DetalleFormula } from '../models/detalleformula';
import { Formula } from '../models/formula';
import { FormulaImport } from '../models/formula-import';
import { FormulaColor } from '../models/formulacolor';
import { FormulaColorView } from '../models/formulacolorview';
import { Medida } from '../models/medida';
import { ParamsPlantilla } from '../models/paramsplantilla';
import { Sistema } from '../models/sistema';
import { Subformula } from '../models/subformula';
import { AppConfigService } from './config/app.config.service';

@Injectable({ providedIn: 'root' })
export class FormulaService {

    constructor(private http: HttpClient,
        private confServ: AppConfigService) {
    }

    buscarFormulasColor(params: ParamsPlantilla): Observable<FormulaColorView[]> {
        return this.http.post<FormulaColorView[]>(`${this.confServ.getConfig().apiUrl}/formulas/buscarformulas`, params);
    }

    getFormulaById(idsistema: number, id: string) {
        return this.http.get<Formula>(`${this.confServ.getConfig().apiUrl}/formulas/sistema/${idsistema}/formula/${id}`);
    }

    getSubformulas(idsistema: number, id: string) {
        return this.http.get<Subformula[]>(`${this.confServ.getConfig().apiUrl}/formulas/sistema/${idsistema}/formula/${id}/subformulas`);
    }

    getConversion_old(idsistema: number, id: string, convertirA: Medida, cantidad: number) {
        return this.http.post<DetalleFormula[]>(`${this.confServ.getConfig().apiUrl}/formulas/sistema/${idsistema}/formula/${id}/convertir/${cantidad}`, convertirA);
    }

    getConversion(idsistema: number, idformula: string, idcolor: number, convertirA: Medida, cantidad: number) {
        return this.http.post<DetalleFormula[]>(`${this.confServ.getConfig().apiUrl}/formulas/sistema/${idsistema}/formula/${idformula}/color/${idcolor}/convertir/${cantidad}`, convertirA);
    }

    getAutocolor(idcolor: number) {
        //cambiar
        return this.http.get<Autocolor>(`${this.confServ.getConfig().apiUrl}/formulas/autocolor/${idcolor}`);
    }

    getFormulaColorById(idsistema: number, idformula: string, idcolor: number) {
        return this.http.get<FormulaColor>(`${this.confServ.getConfig().apiUrl}/formulas/formulacolor/sistema/${idsistema}/formula/${idformula}/color/${idcolor}`);
    }

    prepararFormula(fc: FormulaColor): Observable<number> {
        return this.http.post<number>(`${this.confServ.getConfig().apiUrl}/formulas/formulacolor/preparar`, fc);
    }


    getSistemas(): Observable<Sistema[]> {
        return this.http.get<Sistema[]>(`${this.confServ.getConfig().apiUrl}/formulas/sistemas`);
    }

    getSistema(id: number): Observable<Sistema> {
        const url = `${this.confServ.getConfig().apiUrl}/formulas/sistemas/${id}`;
        return this.http.get<Sistema>(url);
    }


    getAllMedidas() {
        return this.http.get<Medida[]>(`${this.confServ.getConfig().apiUrl}/formulas/medidas`);
    }

    getMedidaById(id: number) {
        return this.http.get<Medida>(`${this.confServ.getConfig().apiUrl}/formulas/medidas/${id}`);
    }

    // ADMIN:

    nuevaFormulaImportada(formulaImport: FormulaImport) {
        const url = `${this.confServ.getConfig().apiUrlMtto}/formulas/importar`;
        return this.http.post<DetalleFormula[]>(url, formulaImport);
    }

    actualizarFormula(formula: Formula) {
        return this.http.put<Formula>(`${this.confServ.getConfig().apiUrlMtto}/formulas`, formula);
    }

    agregarDetalle(idsistema: number, id: string, detalle: DetalleFormula) {
        return this.http.post<DetalleFormula>(`${this.confServ.getConfig().apiUrlMtto}/formulas/sistema/${idsistema}/formula/${id}/detalle`, detalle);
    }

    actualizarDetalle(detalle: DetalleFormula) {
        return this.http.put<DetalleFormula>(`${this.confServ.getConfig().apiUrlMtto}/formulas/detalle/`, detalle);
    }

    reemplazarTintes(idsistema: number, codigotinteAnterior: string, codigoTinteNuevo: string) {
        return this.http.get<Formula[]>(`${this.confServ.getConfig().apiUrlMtto}/formulas/detalle/reemplazartinte/sistema/${idsistema}/anterior/${codigotinteAnterior}/nuevo/${codigoTinteNuevo}`);
    }

    eliminarDetalle(idsistema: number, idformula: string, codigoTinte: string) {
        return this.http.delete<DetalleFormula>(`${this.confServ.getConfig().apiUrlMtto}/formulas/detalle/sistema/${idsistema}/formula/${idformula}/${codigoTinte}`);
    }

    // subformulas

    agregarSubformula(idsistema: number, id: string, sub: Subformula) {
        return this.http.post<Subformula>(`${this.confServ.getConfig().apiUrlMtto}/formulas/sistema/${idsistema}/formula/${id}/subformulas`, sub);
    }

    actualizarSubformula(idsistema: number, id: string, sub: Subformula) {
        return this.http.put<Subformula>(`${this.confServ.getConfig().apiUrlMtto}/formulas/sistema/${idsistema}/formula/${id}/subformulas`, sub);
    }

    eliminarSubformula(idsistema: number, idpadre: string, idformula: string) {
        return this.http.delete<Subformula>(`${this.confServ.getConfig().apiUrlMtto}/formulas/sistema/${idsistema}/formula/${idpadre}/subformulas/${idformula}`);
    }

    getHistoricoDetalleFormula(idsistema: number, id: string) {
        return this.http.get<DetalleFormulaAudit[]>(`${this.confServ.getConfig().apiUrlMtto}/formulas/detalle/sistema/${idsistema}/formula/${id}/historia`);
    }

}